import { Flex, Image } from "@chakra-ui/react";

export default function LogoMobile({logo}) {
  return (
    <Flex
      flex={{ base: 1 }}
      justify="flex-start"
      display={["flex", "none"]}
    >
      <Image src={logo} alt="Geração Social" height="60px" />
    </Flex>
  );
}